//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, {
  CancelToken
} from 'axios'

export default {
  data() {
    return {
      UserAccessData: {},
      wkS: '',
      wkE: '',
      weeks: [],
      vProcess: '',
      Processs: [],
      vGroup: 'ALL',
      Groups: [],
      GroupIn: '',
      DocData: [],
      SampleData: [],
      PatternData: [],
      FCData: [],
      SewData: [],
      PackData: [],
      FABData: [],

      // filter_doc: '',
      // filter_sample: '',
      // filter_fc: '',
      // filter_pattern: '',
      // filter_sew: '',
      // filter_pack: '',
      // filter_fab: '',
      // pagination: {
      //   sortBy: 'desc',
      //   descending: false,
      //   page: 1,
      //   rowsPerPage: -1
      // },
    }
  },
  watch: {
    // whenever question changes, this function will run
    vProcess: function (newValue, oldValue) {

      if (newValue == 'Document' || newValue == 'Sample') {
        this.Groups = this.UserAccessData.MerList
        this.vGroup = this.UserAccessData.MerList[0]
        this.GroupIn = this.UserAccessData.MerIn
      }
      if (newValue == 'FAB') {
        this.Groups = this.UserAccessData.FABList
        this.vGroup = this.UserAccessData.FABList[0]
        this.GroupIn = this.UserAccessData.FABIn
      }
      if (newValue == 'Sew' || newValue == 'Pack') {
        this.Groups = ['ALL', 'G1', 'G2', 'G3', 'G4', 'GW', 'NYV1', 'TRM']
        // this.Groups = ['ALL']
        this.vGroup = 'ALL'
        this.GroupIn = "'G1','G2','G3','G4','GW','NYV1','TRM'"
      }
      if (newValue == 'FC') {
        this.Groups = this.UserAccessData.QAList
        this.vGroup = this.UserAccessData.QAList[0]
        this.GroupIn = this.UserAccessData.QAIn
      }
      if (newValue == 'Pattern') {
        this.Groups = this.UserAccessData.PatternList
        this.vGroup = this.UserAccessData.PatternList[0]
        this.GroupIn = this.UserAccessData.PatternIn
      }
    }
  },
  async created() {
    this.TargetWK()
    let a = await this.getUserAccessData()
    this.LoadData()
    // console.log('create')
  },
  methods: {

    getUserAccessData() {
      let params = new FormData()
      params.append("uid", this.$store.getters.uid)
      const obj = axios({
        method: "post",
        url: this.$api + 'master.php/UserAccessData',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.UserAccessData = res.data
        this.Processs = res.data.ProcessList
        this.vProcess = res.data.ProcessList[0]
        // console.log('1')
      })

      return obj;
    },

    TargetWK() {

      let params = new FormData()

      const obj = axios({
        method: "post",
        url: this.$api + 'master.php/targetWk',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.weeks = res.data.Weeks
        this.wkS = res.data.wkS
        this.wkE = res.data.wkE
        // console.log('2')
      })

      return obj;

    },

    LoadData() {

      //
      //
      this.QueryDocument()
      this.QuerySample()
      this.QueryFAB()
      this.QuerySew()
      this.QueryPack()
      this.QueryFC()
      this.QueryPattern()

      if (this.vProcess == 'Document') {

      }

      if (this.vProcess == 'Sample') {

      }

      if (this.vProcess == 'FAB') {

      }

      if (this.vProcess == 'Sew') {

      }

      if (this.vProcess == 'Pack') {

      }
      if (this.vProcess == 'FC') {

      }

      if (this.vProcess == 'Pattern') {

      }

    },

    QueryDocument() {
      // console.log(this.vGroup)
      let params = new FormData()
      params.append("groupIn", this.GroupIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_doc",
        data: params
      }).then(res => {
        console.log(res.data)
        this.DocData = res.data
      })

    },

    QuerySample() {
      // console.log(this.vGroup)
      let params = new FormData()
      params.append("groupIn", this.GroupIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_sample",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.SampleData = res.data
      })

    },

    QueryFAB() {
      // console.log(this.vGroup)
      let params = new FormData()
      params.append("groupIn", this.UserAccessData.FABIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_fab",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.FABData = res.data.data
      })

    },

    QuerySew() {
      let params = new FormData()
      params.append("groupIn", this.UserAccessData.SEWIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_sew",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.SewData = res.data.data
      })
    },

    QueryPack() {
      let params = new FormData()
      params.append("groupIn", this.UserAccessData.SEWIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_pack",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.PackData = res.data.data
      })
    },

    QueryFC() {
      let params = new FormData()
      params.append("groupIn", this.UserAccessData.QAIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_fc",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.FCData = res.data
      })
    },

    QueryPattern() {
      let params = new FormData()
      params.append("groupIn", this.UserAccessData.PatternIn)
      params.append("group", this.vGroup)
      params.append("periodFrom", this.wkS)
      params.append("periodTo", this.wkE)
      axios({
        method: "post",
        url: this.$api + "readinessQuery.php/ready_distribute_pattern",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.PatternData = res.data
      })
    },

    getPercent(act, total) {
      let p = act * 100 / total
      if (p > 0) {
        return p.toFixed(2)
      } else {
        return ''
      }
    },
    getOntime6(obj) {
      let ot11 = parseFloat(obj.WK005)
      let ot10 = parseFloat(obj.WK004)
      let ot09 = parseFloat(obj.WK003)
      let ot08 = parseFloat(obj.WK002)
      let ot07 = parseFloat(obj.WK001)
      let ot06 = parseFloat(obj.WK00)

      let hit = ot06 + ot07 + ot08 + ot09 + ot10 + ot11
      let p = hit * 100 / parseFloat(obj.CNT_SO)

      if (p > 0) {
        return p.toFixed(2)
      } else {
        return '0'
      }
    },
    getOntimed3(obj) {
      let ot000 = parseFloat(obj.DY_000_HIT)
      let ot00 = parseFloat(obj.DY_00_HIT)
      let ot01 = parseFloat(obj.DY_01_HIT)
      let ot02 = parseFloat(obj.DY_02_HIT)
      let ot03 = parseFloat(obj.DY_03_HIT)

      let hit = ot02 + ot01 + ot00 + ot000 + ot03
      let p = hit * 100 / parseFloat(obj.CNT_SO)

      if (p > 0) {
        return p.toFixed(2)
      } else {
        return '0'
      }
    },
    getOntimed2(obj) {
      let ot000 = parseFloat(obj.DY_000_HIT)
      let ot00 = parseFloat(obj.DY_00_HIT)
      let ot01 = parseFloat(obj.DY_01_HIT)
      let ot02 = parseFloat(obj.DY_02_HIT)

      let hit = ot02 + ot01 + ot00 + ot000
      let p = hit * 100 / parseFloat(obj.CNT_SO)

      if (p > 0) {
        return p.toFixed(2)
      } else {
        return '0'
      }
    }
  }
}
